/**
 * @generated SignedSource<<208166b39d5656af805785c37b05f8e5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type TrackUnsplashPhotoInput = {
  clientMutationId?: string | null | undefined;
  unsplashImageId: string;
};
export type UnsplashImagesTrackMutation$variables = {
  input: TrackUnsplashPhotoInput;
};
export type UnsplashImagesTrackMutation$data = {
  readonly trackUnsplashPhoto: {
    readonly clientMutationId: string | null | undefined;
  } | null | undefined;
};
export type UnsplashImagesTrackMutation = {
  response: UnsplashImagesTrackMutation$data;
  variables: UnsplashImagesTrackMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "TrackUnsplashPhotoPayload",
    "kind": "LinkedField",
    "name": "trackUnsplashPhoto",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UnsplashImagesTrackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UnsplashImagesTrackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "633168b0b68133eaa047a6970940b234",
    "id": null,
    "metadata": {},
    "name": "UnsplashImagesTrackMutation",
    "operationKind": "mutation",
    "text": "mutation UnsplashImagesTrackMutation(\n  $input: TrackUnsplashPhotoInput!\n) {\n  trackUnsplashPhoto(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();

(node as any).hash = "1088b0707f21348ad502a27db4d99c47";

export default node;
